import { render, staticRenderFns } from "./design_quotes.vue?vue&type=template&id=3a82104c"
import script from "./design_quotes.vue?vue&type=script&lang=js"
export * from "./design_quotes.vue?vue&type=script&lang=js"
import style0 from "./design_quotes.vue?vue&type=style&index=0&id=3a82104c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports